import { emptySplitApi } from '@/store/emptyApi';
import { TeamCommitment, PerformanceMetricOption, TeamBioData } from '../types';

export const teamCommitmentApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getTeamCommitment: build.query<TeamCommitment | null, { teamId: number; assessmentPeriodId: number }>({
      query: ({ teamId, assessmentPeriodId }) => ({
        url: '/api/portal/v1/assessments/team-commitment/',
        params: {
          team_id: teamId,
          assessment_period_id: assessmentPeriodId,
        },
      }),
      providesTags: (result, error, { teamId, assessmentPeriodId }) => [
        { type: 'TeamCommitment', id: `${teamId}-${assessmentPeriodId}` },
      ],
    }),

    saveTeamCommitment: build.mutation<TeamCommitment, Partial<TeamCommitment>>({
      query: (commitment) => ({
        url: '/api/portal/v1/assessments/team-commitment/',
        method: 'POST',
        body: {
          team_id: commitment.team_id,
          assessment_period_id: commitment.assessment_period_id,
          selected_metrics: commitment.selected_metrics || [],
          metric_benchmarks: commitment.metric_benchmarks || {},
          success_criteria_notes: commitment.success_criteria_notes || '',
        },
      }),
      invalidatesTags: (result, error, commitment) => [
        { type: 'TeamCommitment', id: `${commitment.team_id}-${commitment.assessment_period_id}` },
        { type: 'TeamBio', id: `${commitment.team_id}-${commitment.assessment_period_id}` },
      ],
    }),

    getAvailableMetrics: build.query<PerformanceMetricOption[], { teamId: number }>({
      query: ({ teamId }) => ({
        url: '/api/portal/v1/assessments/team-commitment/available_metrics/',
        params: {
          team_id: teamId,
        },
      }),
    }),

    getTeamBio: build.query<TeamBioData, { teamId: number; assessmentPeriodId: number }>({
      query: ({ teamId, assessmentPeriodId }) => ({
        url: '/api/portal/v1/assessments/team-commitment/team_bio/',
        params: {
          team_id: teamId,
          assessment_period_id: assessmentPeriodId,
        },
      }),
      providesTags: (result, error, { teamId, assessmentPeriodId }) => [
        { type: 'TeamCommitment', id: `${teamId}-${assessmentPeriodId}` },
        { type: 'TeamBio', id: `${teamId}-${assessmentPeriodId}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTeamCommitmentQuery,
  useSaveTeamCommitmentMutation,
  useGetAvailableMetricsQuery,
  useGetTeamBioQuery,
} = teamCommitmentApi;

